
        var result = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./context-permissions.component.styl");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/lib/context/context-permissions/context-permissions.component.styl
// module id = 981
// module chunks = 0